<template>
    <div class="painterBtn" v-show="judgeBox">
        <div
            class="submit"
            :class="{disabled: btnDisabled}"
            @click="propsEvent('submit')"
        >
          提交审核
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
  },
  data () {
    return {
      templateData: {},
      judgeOnce: true
    };
  },
  computed: {
    ...mapGetters([
      'TopnavMsg',
      'StyleArrayMsg',
      'TOOL',
      'WorksProjectId',
      'WorksId'
    ])
  },
  props: {
    'judgeBox': {},
    'formData': {},
    'painterVideoUrl': {},
    'unlock': {},
    btnDisabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'judgeBox': function () {
      if (this.judgeBox) {
        this.judgeOnce = true;
      }else {
        this.templateData = {};
      }
    },
    'painterVideoUrl': function () {
      if (this.painterVideoUrl) {
        this.submitTemplate();
      }
    }

  },
  created () {
    if (this.judgeBox) {
      this.judgeOnce = true;
    }else {
      this.templateData = {};
    }
  },
  mounted () {
  },
  methods: {
    submitTemplate (data) {
      if (!this.judgeOnce) return;
      this.judgeOnce = false;
      let dataurl = '/api/user/template';
      let template = {

      };
      switch (this.TopnavMsg.transferData.type) {
        case 'template':
          // const painterSubmitRef = this.$parent.$children.find(v => v.$options._componentTag === 'painterSubmit');
          // const {templateCates, templateSelectedCates, childCateTable} = painterSubmitRef;
          if (!this.painterVideoUrl.painterVideoUrl) {
            this.painterVideoUrl.painterVideoUrl = 'none/none.mp4';
            this.$message({
              type: 'error',
              message: '获取视频失败'
            });
          }
          let templateGames = {
            ids: []
          };
          this.$bus.emit('getTemplateGames', templateGames);
          template = {
            thumbnailUrl: this.painterVideoUrl.screen,
            description: this.painterVideoUrl.description,
            title: this.painterVideoUrl.title,
            // data: this.painterVideoUrl.data,
            data: this.getTemplateDataString(),
            videoUrl: this.painterVideoUrl.painterVideoUrl,
            tags: this.painterVideoUrl.tags,
            duration: this.painterVideoUrl.times,
            direction: this.painterVideoUrl.direction,
            // payType: this.formData.payType,
            price: this.formData.price,
            // categories: this.formData.categories.join(','),
            categories: this.getCategoriesString(),
            styles: this.formData.labelStyle.join(','),
            platform: this.TopnavMsg.transferData.platform,
            projectId: this.WorksProjectId
          };
          if (templateGames.ids.length) {
            template.activityIds = templateGames.ids;// .join(',');
          }
          break;
        case 'updataTemplate':
          if (!this.painterVideoUrl.painterVideoUrl) {
            this.painterVideoUrl.painterVideoUrl = 'none/none.mp4';
            this.$message({
              type: 'error',
              message: '获取视频失败'
            });
          }
          dataurl = '/api/user/template/updateData';
          template = {
            videoUrl: this.painterVideoUrl.painterVideoUrl,
            id: this.TopnavMsg.transferData.id,
            data: this.painterVideoUrl.data,
            duration: this.painterVideoUrl.times,
            thumbnailUrl: this.painterVideoUrl.screen,
            platform: 6
          };
          this.$http.put(`/api/user/template/${template.id}`, {
            price: '',
            thumbnailUrl: template.thumbnailUrl,
            title: this.painterVideoUrl.title,
            tags: this.painterVideoUrl.tags,
            categories: this.getCategoriesString()
          })
          break;
        case 'combination':
          let jsonData = this.TOOL.toJson();
          jsonData = jsonData.scenes[this.TOOL.selectedScenes.index].sprites;
          template = {
            title: this.painterVideoUrl.title,
            fileType: 30,
            thumbnailUrl: this.painterVideoUrl.screen,
            data: JSON.stringify(jsonData),
            categories: this.formData.categories.join(','),
            platform: 6
          };
          if (!$('.form-field__content.combination').children().length) {
            this.$message({
              type: 'error',
              message: '导出素材组合失败，请选择分类'
            });
            return;
          }
          switch (this.formData.combinationType) {
            case 'text':
              dataurl = '/api/user/text';
              template.description = this.painterVideoUrl.description;
              break;
            case 'prop':
              dataurl = '/api/user/prop';
              break;
            case 'shape':
              dataurl = '/api/user/shape';
              break;
          }
          break;
      }
      this.$http.post(dataurl, template).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: '提交数据成功',
            type: 'success'
          });
          switch (this.TopnavMsg.transferData.type) {
            case 'combination':
              this.propsEvent('close');
              break;
            default:

              this.propsEvent('openPage', this.painterVideoUrl.videoId, `&type=8 `);
          }
        }else {
          this.$message({
            message: res.data.msg || '提交数据失败',
            type: 'error'
          });
          this.unlock && this.unlock();
        }
      });
    },
    propsEvent (name, data, dataTwo) {
      if (this.btnDisabled) return;
      this.$emit(name, data, dataTwo);
    },
    getCategoriesString () {
      const painterSubmitRef = this.$parent.$children.find(v => v.$options._componentTag === 'painterSubmit');
      const { templateSelectedCates } = painterSubmitRef;
      return templateSelectedCates.join(',');
    },
    getTemplateDataString () {
      const type = this.TopnavMsg.transferData.platform == 2 ? 'App' : void 0;
      const data = this.TOOL.toJson(type);
      return data ? JSON.stringify(data) : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.painterBtn {
    display: flex;
    justify-content: center;
    height: auto;
    width: 100%;
    border-top: 1px solid #eaeaf4;

    .submit{
        width: 160px;
        height: 40px;
        background-color: #5778fb;
        border-radius: 4px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 40px;
        letter-spacing: 0px;
        color: #ffffff;
        margin-top: 50px;
        &.disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/exportDialog/painterBtn.vue